const fnv1a = (value: string) => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < value.length; i++) {
    hash = Math.imul(hash ^ value.charCodeAt(i), 0x01000193);
  }
  return hash >>> 0;
};

export const seedGradient = (seed: string) => {
  const hash = fnv1a(seed);
  const from = hash % 360;
  const to = (from + 30 + ((hash >>> 9) % 60)) % 360;
  const angle = (hash >>> 18) % 360;
  return `linear-gradient(${angle}deg, hsl(${from} 80% 62%), hsl(${to} 75% 46%))`;
};
